import { defineStore } from 'pinia'
import { ref, computed } from 'vue'

export const useDepartmentsStore = defineStore('departments', () => {
  const items = ref([])

  const setItems = (newItems) => {
    items.value = newItems
  }

  const getItems = computed(() => items.value)

  const getDepartmentsRelatedToEmployee = computed(() => (slug) => {
    return items.value.filter((item) => {
      if (item?.DepartmentFields?.humanResources) {
        return item.DepartmentFields.humanResources.find((human) => {
          return human?.resource?.slug === slug
        })
      }
      return false
    })
  })

  return {
    items,
    setItems,
    getItems,
    getDepartmentsRelatedToEmployee,
  }
})
